import AppContext from "@/contexts/appctx/app-context";
import ContributeInfo from "@/seed/components/elements/contribute-info";
import VestingSchedule from "@/seed/components/elements/vesting-schedule";
import TokenSaleHero from "@/seed/components/modules/token-sale/token-sale-hero";
import PoolContext from "@/seed/contexts/pool/pool-context";
import { getContributionReceipt } from "@/seed/utils/user-info";
// import { data as userWalletData} from "@/seed/shared/user-wallet";
import { useContext } from "react";

const TokenPurchaseClose = () => {
    const { layoutContentDef, saleEvent } = useContext(PoolContext);
    const { user } = useContext(AppContext);

    if (!layoutContentDef || !saleEvent) return <div>Loading</div>; // || !user

    console.log("TokenPurchaseClose", { user });

    let contributeInfo;
    let vestingSchedule;
    let allocations;
    let userWalletData;
    if (user) {
        userWalletData = user.ether;
        allocations = user.allocations;

        if (user?.isPurchased && allocations?.length) {
            const selectedIndex = 0;
            const selectedAllocation = allocations[selectedIndex];

            contributeInfo = getContributionReceipt(
                selectedAllocation,
                null,
                saleEvent.acceptedCurrency
            );

            // TODO: check from smart contract or BE
            if (selectedAllocation.vestingSchedule) {
                vestingSchedule = { ...layoutContentDef.tokenSaleHero.vestingSchedule };
                if (vestingSchedule.schedule) {
                    vestingSchedule.schedule.rows =
                        selectedAllocation?.vestingSchedule?.details || [];
                    vestingSchedule.paging = {
                        total: selectedAllocation?.vestingSchedule.totalTimes,
                        itemsPerPage: 5,
                    };
                }
            }
        }
    }

    console.log("TokenPurchaseClose", {
        layoutContentDef,
        saleEvent,
        userWalletData,
        contributeInfo,
        vestingSchedule,
    });

    return (
        <>
            <div className="absolute">
                <section id="hero" className="bg-[url('/img/hero.png')] bg-center bg-cover">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
                <section id="user-guide" className="">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
            </div>
            <div className="absolute w-screen top-[20%] landscape:top-[30%]">
                <div className="container mx-auto flex flex-col items-center justify-center w-full">
                    <TokenSaleHero
                        data={{
                            ...layoutContentDef.tokenSaleHero,
                            // countdown: {
                            //     ...layoutContentDef.tokenSaleHero.countdown,
                            //     ...saleEvent.countdown,
                            // },
                            saleInfo: saleEvent,
                        }}
                        userWallet={userWalletData}
                    />
                    <div className="flex flex-col items-center lg:items-start lg:flex-row w-full md:w-[80%] xl:w-[60%] mt-10 md:mt-16 lg:space-x-7 space-y-7 md:space-y-10 lg:space-y-0">
                        <div className="w-full lg:w-[40%] shrink-0">
                            {contributeInfo ? (
                                <ContributeInfo data={contributeInfo.details} />
                            ) : undefined}
                        </div>
                        <div className="w-full lg:w-[60%]">
                            {vestingSchedule ? (
                                <VestingSchedule data={vestingSchedule} />
                            ) : undefined}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TokenPurchaseClose;
